export default "__VITE_ASSET__BclOQ$Ni__"